import React from 'react';
import DialogBox from "../../components/DialogBox";
import PortfolioChatbot from "../../components/PortfolioChatbot";
import style from "../style.module.css";

const Chatbot = ({ portfolioPdfUrl, onClose }) => {
    return (
        <DialogBox onClose={onClose} padding={false}>
            <PortfolioChatbot className={style.landbot} portfolioPdfUrl={portfolioPdfUrl} />
        </DialogBox>
    )
}

export default Chatbot;
